export enum ResourceType {
    MyShipments = 'MyShipments',
    ExternalShipment = 'ExternalShipment'
}
